import type { HelpConfig } from '#types/config/pages/help'
import type { RecursivePartial } from '#types/utils'

export default {
  titleBelowBreadcrumb: true
} satisfies RecursivePartial<HelpConfig>
